/**
 * Warranty-guard basket-error detektálás (27-kör B-scope + #653 code-upgrade).
 *
 * A #647 BE-guard garanciás worksheet-nél 400-at dob; a #653 óta strukturált
 * error-code-dal (`WARRANTY_NOT_BILLABLE`) az `ApiError.code`-ban. A FE elsősorban
 * a code-ot detektálja (nyelv-/refaktor-független, robusztus), és defense-in-depth
 * a nyers magyar message-substringre is visszaesik (régi BE / hiányzó code esetén).
 */
import { ApiError } from '@/api/client';

export function isWarrantyBasketError(err: unknown): boolean {
  // Elsődleges: a #653 BE error-code (nyelv-független, robusztus)
  if (err instanceof ApiError && err.code === 'WARRANTY_NOT_BILLABLE') {
    return true;
  }
  // Fallback (defense-in-depth): nyers hu message-substring (régi BE / hiányzó code)
  return err instanceof Error && /garanci/i.test(err.message);
}
